<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div class="ma-15">
      <v-card>
        <v-card-title class="primary--text"> KLeuren </v-card-title>
      </v-card>
      <v-simple-table>
        <thead>
        <tr>
          <th class="text-left text-uppercase" width="400px"></th>
          <th class="text-left text-uppercase">waarde</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="text-uppercase" widht="200px">
          Primaire Kleur
          </td>
          <td>{{ dataext.colorA }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">Secundaire kleur</td>
          <td>{{ dataext.colorB }}</td>
        </tr>
        <tr></tr>
        <tr>
          <td class="text-uppercase">Positieve waarde familiestatuut</td>
          <td>{{ dataext.colorC }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">Negatieve waarde familiestatuut</td>
          <td>{{ dataext.colorD }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">Extra kleur</td>
          <td>{{ dataext.colorD }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">Breedte logo</td>
          <td>{{ dataext.breedteA }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">www adres tbv powerpoint</td>
          <td>{{ dataext.wwwadres }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">PPTX naam </td>
          <td>{{ dataext.pptxnaam }}</td>
        </tr>
        </tbody>
      </v-simple-table>

      <FlashMessage :error="error" v-if="error" key="error" />

      <v-col class="text-right">
        <v-btn class="mt-15" color="accent" @click="editItem()">{{
            $t("crud.change")
          }}</v-btn>
      </v-col>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import FlashMessage from "@/components/input/FlashMessage";
import ColorService from "@/services/maintain/ColorService";
export default {
  name: "fchartmemberIndex",
  components: { FlashMessage, ToolbarAuth, Navigation },
  data() {
    return {
      loading: false,
      error: null,
      dialogDelete: false,
      itemToDelete: {},
      dataext: {},
    };
  },
  methods: {
    getData() {
      this.loading = true;
      let Id = 1;
      ColorService.getMains(Id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },

    editItem() {
      this.$router.push({ name: "colorsEdit" });
    },
  },
  computed: {},
  created() {
    this.getData();
  },
  beforeDestroy() {},
};
</script>

<style scoped></style>
